import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import SkinSelector from '../CommonProperties/SkinSelector';

const UnilevelLegsProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  const handleComponentPropsChange = (property, value) => {
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      {/* 스킨 선택 */}
      <SkinSelector 
        selectedComponent={selectedComponent}
        onSkinChange={(skinId) => handleComponentPropsChange('skin', skinId)}
      />
      
      {/* 기본 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11H7a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-2M9 11V8a3 3 0 116 0v3M9 11h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          기본 설정
        </div>
        
        <div className="property-control">
          <label>제목</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.title || "추천 레그"}
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showDebugMode || false}
              onChange={(e) => handleComponentPropsChange('showDebugMode', e.target.checked)}
            />
            디버그 모드 표시
          </label>
        </div>
      </div>
      
      {/* 표시 옵션 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/>
            <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/>
          </svg>
          표시 옵션
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNavigationButtons !== false}
              onChange={(e) => handleComponentPropsChange('showNavigationButtons', e.target.checked)}
            />
            네비게이션 버튼 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showBreadcrumb !== false}
              onChange={(e) => handleComponentPropsChange('showBreadcrumb', e.target.checked)}
            />
            브레드크럼 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showZoomControls !== false}
              onChange={(e) => handleComponentPropsChange('showZoomControls', e.target.checked)}
            />
            줌 컨트롤 표시
          </label>
        </div>
      </div>
      
      {/* 노드 정보 표시 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M9 9h6M9 12h6M9 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          노드 정보 표시
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNodePV !== false}
              onChange={(e) => handleComponentPropsChange('showNodePV', e.target.checked)}
            />
            PV 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNodeRank !== false}
              onChange={(e) => handleComponentPropsChange('showNodeRank', e.target.checked)}
            />
            등급 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNodeGrade !== false}
              onChange={(e) => handleComponentPropsChange('showNodeGrade', e.target.checked)}
            />
            직급 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNodePhone !== false}
              onChange={(e) => handleComponentPropsChange('showNodePhone', e.target.checked)}
            />
            전화번호 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNodeCenter !== false}
              onChange={(e) => handleComponentPropsChange('showNodeCenter', e.target.checked)}
            />
            센터 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showNodeGroupPV !== false}
              onChange={(e) => handleComponentPropsChange('showNodeGroupPV', e.target.checked)}
            />
            그룹 PV 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showMoreButton !== false}
              onChange={(e) => handleComponentPropsChange('showMoreButton', e.target.checked)}
            />
            더보기 버튼 표시
          </label>
        </div>
      </div>
      
      {/* 줌 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
            <path d="M21 21l-4.35-4.35M11 8v6M8 11h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          줌 설정
        </div>
        
        <div className="property-control">
          <label>초기 줌 레벨</label>
          <input 
            type="number" 
            min="0.3" 
            max="2.5" 
            step="0.1"
            value={selectedComponent.componentProps?.initialZoom || 1}
            onChange={(e) => handleComponentPropsChange('initialZoom', parseFloat(e.target.value))}
          />
        </div>
        
        <div className="property-control">
          <label>최소 줌</label>
          <input 
            type="number" 
            min="0.1" 
            max="1" 
            step="0.1"
            value={selectedComponent.componentProps?.minZoom || 0.3}
            onChange={(e) => handleComponentPropsChange('minZoom', parseFloat(e.target.value))}
          />
        </div>
        
        <div className="property-control">
          <label>최대 줌</label>
          <input 
            type="number" 
            min="1" 
            max="5" 
            step="0.1"
            value={selectedComponent.componentProps?.maxZoom || 2.5}
            onChange={(e) => handleComponentPropsChange('maxZoom', parseFloat(e.target.value))}
          />
        </div>
      </div>
      
      {/* 색상 테마 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
          </svg>
          색상 테마
        </div>
        
        <div className="property-control">
          <label>연결선 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.lineColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('lineColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>노드 배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.nodeBackgroundColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('nodeBackgroundColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>노드 테두리 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.nodeBorderColor || "#e0e0e0"}
            onChange={(e) => handleComponentPropsChange('nodeBorderColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>제목 배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.titleBackgroundColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('titleBackgroundColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>제목 텍스트 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.titleTextColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('titleTextColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>내용 텍스트 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.contentTextColor || "#333333"}
            onChange={(e) => handleComponentPropsChange('contentTextColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>뱃지 배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.bubbleBadgeColor || "#2196f3"}
            onChange={(e) => handleComponentPropsChange('bubbleBadgeColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>뱃지 텍스트 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.bubbleBadgeTextColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('bubbleBadgeTextColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 버튼 색상 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
            <circle cx="12" cy="12" r="2" fill="currentColor"/>
          </svg>
          버튼 색상
        </div>
        
        <div className="property-control">
          <label>주 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.buttonPrimaryColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('buttonPrimaryColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>보조 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.buttonSecondaryColor || "#6c757d"}
            onChange={(e) => handleComponentPropsChange('buttonSecondaryColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>성공 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.buttonSuccessColor || "#28a745"}
            onChange={(e) => handleComponentPropsChange('buttonSuccessColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>위험 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.buttonDangerColor || "#dc3545"}
            onChange={(e) => handleComponentPropsChange('buttonDangerColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 컨테이너 스타일 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
          </svg>
          컨테이너 스타일
        </div>
        
        <div className="property-control">
          <label>배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.containerBackgroundColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('containerBackgroundColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>브레드크럼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.breadcrumbColor || "#666666"}
            onChange={(e) => handleComponentPropsChange('breadcrumbColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>브레드크럼 활성 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.breadcrumbActiveColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('breadcrumbActiveColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 텍스트 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M18 2l4 4-10 10H8v-4L18 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          텍스트 설정
        </div>
        
        <div className="property-control">
          <label>빈 데이터 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.emptyText || "데이터가 없습니다"}
            onChange={(e) => handleComponentPropsChange('emptyText', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>로딩 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.loadingText || "조직도를 불러오는 중입니다..."}
            onChange={(e) => handleComponentPropsChange('loadingText', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>에러 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.errorText || "데이터를 불러오는데 실패했습니다"}
            onChange={(e) => handleComponentPropsChange('errorText', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>로그인 필요 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.loginRequiredText || "로그인이 필요한 서비스입니다."}
            onChange={(e) => handleComponentPropsChange('loginRequiredText', e.target.value)}
          />
        </div>
      </div>
    </>
  );
};

export default UnilevelLegsProperties;